export const towns = {
  ab: [
    "Airdrie",
    "Beaumont",
    "Blackfalds",
    "Bragg Creek",
    "Calgary",
    "Chestemere",
    "Coaldal",
    "Coalhurst",
    "Cochrane",
    "Devon",
    "Dunmore",
    "Edmonton",
    "Fort Saskatchewan",
    "High River",
    "Innisfail",
    "Lacombe",
    "Langdon",
    "Leduc",
    "Lethbridge",
    "Medicine Hat",
    "Morninville",
    "Okotoks",
    "Red Deer",
    "Redcliff",
    "Sherwood Park",
    "Spruce Grove",
    "St. Albert",
    "Stoney Plain",
    "Strathmore",
    "Syvan Lake",
    "Turner Valley"
  ],
  bc: [
    "Abbotsford",
    "Burnaby",
    "Chilliwack",
    "Coldstream",
    "Colwood",
    "Coquitlam",
    "Delta",
    "Esquimalt",
    "Highlands",
    "Kelowna",
    "Langford",
    "Langley",
    "Maple Ridge",
    "Metchosin",
    "Mission",
    "Nanaimo",
    "New Westminster",
    "North Vancouver",
    "Oak Bay",
    "Pitt Meadows",
    "Port Coquitlam",
    "Port Moody",
    "Richmond",
    "Saanich (Central)",
    "Saanich (North)",
    "Saanich (South)",
    "Sidney",
    "Sooke",
    "Surrey",
    "Vancouver East",
    "Vancouver West",
    "Vernon",
    "Victoria",
    "View Royal",
    "West Kelowna",
    "West Vancouver",
    "White Rock"
  ],
  on: [
    "Acton",
    "Ajax",
    "Alliston",
    "Almonte",
    "Amherstview",
    "Ancaster",
    "Arnprior",
    "Aurora",
    "Barrie",
    "Beamsville",
    "Belleville",
    "Bolton",
    "Bowmanville",
    "Bracebridge",
    "Bradford",
    "Brampton",
    "Brantford",
    "Brockville",
    "Brooklin",
    "Burlington",
    "Caledon",
    "Cambridge",
    "Carleton Place",
    "Carp",
    "Casselman",
    "Cobourg",
    "Collingwood",
    "Cornwall",
    "Courtice",
    "Cumberland",
    "Dundas",
    "Dunrobin",
    "Elmira",
    "Elora",
    "Embrun",
    "Etobicoke",
    "Fergus",
    "Fonthill",
    "Georgetown",
    "Gravenhurst",
    "Greely",
    "Grimsby",
    "Guelph",
    "Hamilton",
    "Holland Landing",
    "Huntsville",
    "Ingersoll",
    "Innisfil",
    "Kanata",
    "Kawartha Lakes",
    "Kemptville",
    "Keswick",
    "King City",
    "Kingston",
    "Kitchener ",
    "Limoges",
    "Lindsay",
    "London",
    "Manotick",
    "Maple",
    "Markham",
    "Metcalfe",
    "Milton",
    "Mississauga",
    "Mount Albert",
    "Napanee",
    "Navan",
    "Nepean",
    "New Hamburg",
    "Newcastle",
    "Newmarket",
    "Niagara Falls",
    "Niagara on the Lake",
    "Nobleton",
    "North York",
    "Oakville",
    "Orangeville",
    "Orillia",
    "Orleans",
    "Osgoode",
    "Oshawa",
    "Ottawa",
    "Pembroke",
    "Petawawa",
    "Peterborough",
    "Pickering",
    "Port Colborne",
    "Port Hope",
    "Port Perry",
    "Richmond Hill",
    "Rockland",
    "Rockwood",
    "Russell",
    "Scarborough",
    "Sharon",
    "Shelburne",
    "Simcoe",
    "St Catherines",
    "St. Thomas",
    "Stittsville",
    "Stoney Creek",
    "Stouffville",
    "Stratford",
    "Strathroy",
    "Thornhill",
    "Thorold",
    "Tilsonburg",
    "Toronto",
    "Trenton",
    "Uxbridge",
    "Vaughan",
    "Wasaga Beach",
    "Waterdown",
    "Waterloo ",
    "Welland",
    "Whitby",
    "Woodbridge",
    "Woodstock"
  ],
  any: [
    "Acton",
    "Ajax",
    "Alliston",
    "Almonte",
    "Amherstview",
    "Ancaster",
    "Arnprior",
    "Aurora",
    "Barrie",
    "Beamsville",
    "Belleville",
    "Bolton",
    "Bowmanville",
    "Bracebridge",
    "Bradford",
    "Brampton",
    "Brantford",
    "Brockville",
    "Brooklin",
    "Burlington",
    "Caledon",
    "Cambridge",
    "Carleton Place",
    "Carp",
    "Casselman",
    "Cobourg",
    "Collingwood",
    "Cornwall",
    "Courtice",
    "Cumberland",
    "Dundas",
    "Dunrobin",
    "Elmira",
    "Elora",
    "Embrun",
    "Etobicoke",
    "Fergus",
    "Fonthill",
    "Georgetown",
    "Gravenhurst",
    "Greely",
    "Grimsby",
    "Guelph",
    "Hamilton",
    "Holland Landing",
    "Huntsville",
    "Ingersoll",
    "Innisfil",
    "Kanata",
    "Kawartha Lakes",
    "Kemptville",
    "Keswick",
    "King City",
    "Kingston",
    "Kitchener ",
    "Limoges",
    "Lindsay",
    "London",
    "Manotick",
    "Maple",
    "Markham",
    "Metcalfe",
    "Milton",
    "Mississauga",
    "Mount Albert",
    "Napanee",
    "Navan",
    "Nepean",
    "New Hamburg",
    "Newcastle",
    "Newmarket",
    "Niagara Falls",
    "Niagara on the Lake",
    "Nobleton",
    "North York",
    "Oakville",
    "Orangeville",
    "Orillia",
    "Orleans",
    "Osgoode",
    "Oshawa",
    "Ottawa",
    "Pembroke",
    "Petawawa",
    "Peterborough",
    "Pickering",
    "Port Colborne",
    "Port Hope",
    "Port Perry",
    "Richmond Hill",
    "Rockland",
    "Rockwood",
    "Russell",
    "Scarborough",
    "Sharon",
    "Shelburne",
    "Simcoe",
    "St Catherines",
    "St. Thomas",
    "Stittsville",
    "Stoney Creek",
    "Stouffville",
    "Stratford",
    "Strathroy",
    "Thornhill",
    "Thorold",
    "Tilsonburg",
    "Toronto",
    "Trenton",
    "Uxbridge",
    "Vaughan",
    "Wasaga Beach",
    "Waterdown",
    "Waterloo ",
    "Welland",
    "Whitby",
    "Woodbridge",
    "Woodstock"
  ]
}



// WEBPACK FOOTER //
// ./src/utils/new-mortgage.data.js